// Utilitário único de documento (CPF / CNPJ), incluindo CNPJ alfanumérico
// (IN RFB nº 2.229/2024). Centraliza a sanitização e a máscara que antes
// estavam duplicadas em FluxoLogin.js, Login.js e useDocumentValidation.js.

// Remove tudo que não é letra/dígito e normaliza para maiúsculas.
export const sanitizeDocument = (value) =>
  (value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()

// Máscara de CPF: 000.000.000-00 (11 dígitos numéricos).
export const maskCpf = (value) =>
  value.replace(/(\d{3})?(\d{3})?(\d{3})?(\d{2})/, '$1.$2.$3-$4')

// Máscara de CNPJ alfanumérico: 00.000.000/0000-00 (14 chars; 2 últimos numéricos).
export const maskCnpj = (value) =>
  value.replace(
    /([A-Z0-9]{2})?([A-Z0-9]{3})?([A-Z0-9]{3})?([A-Z0-9]{4})?(\d{2})/,
    '$1.$2.$3/$4-$5'
  )

// Sanitiza e aplica a máscara adequada conforme o tamanho
// (11 numérico = CPF, 14 = CNPJ). Reproduz fielmente o handle() das telas de login.
export const maskDocument = (value) => {
  const entrada = sanitizeDocument(value)
  if (entrada.length === 11 && /^\d+$/.test(entrada)) {
    return maskCpf(entrada)
  }
  if (entrada.length === 14) {
    return maskCnpj(entrada)
  }
  return entrada
}

// Tipo do documento pelo tamanho do valor sanitizado: 'CPF' | 'CNPJ' | ''.
export const getDocumentTypeByLength = (value) => {
  const limpo = sanitizeDocument(value)
  if (limpo.length === 11) return 'CPF'
  if (limpo.length === 14) return 'CNPJ'
  return ''
}
